import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverUniform from './driver-uniform.jsx';

export default class DriversUniforms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_uniform_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/uniforms',
    };


    this.getDriversUniforms();
  }

  getDriversUniforms() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_uniform_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversUniforms = [];

    if (this.state.drivers_uniform_accounts &&
        this.state.drivers_uniform_accounts.length > 0) {
        this.state.drivers_uniform_accounts.forEach(
          function(i) {
            DriversUniforms.push(
              <DriverUniform
                key={'drivers-uniforms-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversUniforms}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-uniforms')) {
  ReactDOM.render(
    <DriversUniforms
      url = {"/api/v1/portal/drivers/uniforms"}
      message_if_none = 'Uniforms not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-uniforms'
    )
  );
}
